angular.module("ainapp")
    .controller("addDebitNoteController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Debit Note";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Debit Note").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Debit Note").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
        $scope.ColumnWidth = null;
        MainService.TableDesignsbyVoucher("Debit Note").then(function (response) {
           if (response.data != null && response.data != "") {
                $scope.TableDesign = response.data;
                $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
            }
        });

            $scope.getExtramasters();

            $scope.getOldBills = function (data) {
                if (data.Id > 0) {
                    $scope.SelectedCE = data;
                    if ($scope.SelectedCE.Bills == null) {
                        if (data.Account.TypeName == "Creditors" || data.Account.TypeName == "Debtors") {
                            data.Bills = [];
                            $.LoadingOverlay("show", {
                                image: "images/load.gif",
                            });
                            MainService.GetPendingBillAnalysisOld(data.AccountId, data.Id).then(function (response) {
                                if (response.data != null) {
                                    data.Bills = response.data;
                                    angular.forEach(data.Bills, function (e) {
                                        e.TotalPaid = e.TotalPaid - e.Adjustment;
                                        e.BalanceAmount = e.TotalAmount - e.TotalPaid;
                                        e.TotalBalance = e.BalanceAmount - e.Adjustment;
                                    })
                                    // $('#billModal').modal('show');
                                } else {
                                    toastr.warning($scope.LanguageData.ErrorLoadingBills);
                                }
                                $.LoadingOverlay("hide");
                            }, function (err) {
                                $.LoadingOverlay("hide");
                                toastr.error($scope.LanguageData.NetworkError);
                            });

                        }
                    } else {
                        //$('#billModal').modal('show');
                    }
                }
            }

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetDebitNote(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data[0]);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }



            $scope.UpdateDetails = function (data) {

                $scope.CurrentJV = data;
                $scope.CurrentJV.Date = new Date($scope.CurrentJV.Date);
                $scope.VoucherDocs = data.VoucherDocs;

                angular.forEach(data.DebitNoteCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })


                $scope.tempTotalQty = 0;
                $scope.tempUnitPrice = 0;
                $scope.tempGross = 0;
                $scope.tempDiscount = 0;
                $scope.tempVat = 0;

                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {
                    $scope.tempTotalQty = $scope.tempTotalQty + e.Quantity;
                    $scope.tempUnitPrice = $scope.tempUnitPrice + e.UnitPrice;
                    $scope.tempGross = $scope.tempGross + e.Total;
                    $scope.tempDiscount = $scope.tempDiscount + e.Discount;
                    $scope.tempVat = $scope.tempVat + e.TaxValue;


                    var costs = angular.copy($scope.CostCenters);
                    if (e.DebitNoteCosts.length > 0) {
                        angular.forEach(e.DebitNoteCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }

                    $scope.getOldBills(e);

                });

                if (data.DebitNoteDetails.length <= 5) {

                    var temp2 = 5 - data.DebitNoteDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var JVDetails = {

                            Id: 0,
                            AccountId: "",
                            CreditAmount: 0,
                            DebitAmount: 0,
                            Remarks: "",
                            Account: {},
                            CostCenters: angular.copy($scope.CostCenters),
                        }
                        $scope.CurrentJV.DebitNoteDetails.push(JVDetails);
                    }
                }

                console.log($scope.CurrentJV.VehicleCategoryId);
                if ($scope.CurrentJV.VehicleCategoryId > 0) {
                    $scope.getVehicles();
                }
            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Debit Note').then(function (response) {
                $scope.VoucherSet = response.data;
            })

            $scope.Currencies = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencies = response.data;
            })

             $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.Init = function () {

                $scope.expandView = false;

                $scope.ViewVal = 0;

                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.CurrentJV = {
                    Date: new Date(),
                    Remarks: "",
                    VocherNumber: "",
                    TotalDebit: 0,
                    TotalCredit: 0,
                    Id: 0,
                    DebitNoteDetails: [],
                }

                for (var i = 0; i < 10; i++) {

                    var JVDetail = {
                        Id: 0,
                        AccountId: "",
                        CreditAmount: 0,
                        DebitAmount: 0,
                        Remarks: "",
                        Account: {},
                        Flats: [],
                        CostCenters: angular.copy($scope.CostCenters),

                    }

                    $scope.CurrentJV.DebitNoteDetails.push(JVDetail);
                }

                $scope.ErrorText = "";
                $scope.Load = false;

                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Debit Note").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentJV.CurrencyId = $scope.CompanyProfile.BaseCurrencyId;

                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Debit Note").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                    })
                    MainService.GetNextDebitNoteNo().then(function (response) {
                        $scope.CurrentJV.VocherNumber = response.data;
                    });
                }
                 setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);
                 setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);

            }
            $scope.Init();

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Debit Note";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

              $scope.getBills = function (data) {

                $scope.SelectedCE = data;

                if (data.Account.TypeName == "Creditors" || data.Account.TypeName == "Debtors") {
                    data.UnassignedBillsArray = [];
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetPendingBillAnalysis(data.AccountId, "Receipt").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                data.UnassignedBillsArray = response.data;

                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {
                                        angular.forEach(data.UnassignedBillsArrays, function (e) {
                                            data.UnassignedBillsArray.unshift(e);
                                        })
                                    }
                                }

                                // angular.forEach(data.Bills, function (e) {
                                //     e.Adjustment = 0;
                                //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                                // })

                                $scope.SelectedCE.AdjustedTotal = 0;
                                $scope.SelectedCE.BalanceAdjusted = data.Amount;
                                $scope.SelectedCE.UnAssignedAdjusted = 0;

                                //$scope.SelectedCE.GrandTotal = data.Amount;

                                angular.forEach(data.UnassignedBillsArray, function (e) {
                                    $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                })

                                // $scope.autoAdjust();
                                $('#unassignedModal').modal('show');

                            }
                            else {
                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {

                                        $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;
                                        $scope.SelectedCE.AdjustedTotal = 0;
                                        $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                        $scope.SelectedCE.UnAssignedAdjusted = 0;
                                        angular.forEach(data.UnassignedBillsArray, function (e) {
                                            $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                            $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                            $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                        })
                                        $('#unassignedModal').modal('show');

                                    } else {
                                        //$scope.SaveWithConfirm();
                                        $('#unassignedModal').modal('show');
                                    }
                                } else {
                                    // $scope.SaveWithConfirm();
                                    $('#unassignedModal').modal('show');
                                }
                            }
                        } else {

                            if (data.Id > 0) {
                                if (data.UnassignedBillsArrays.length > 0) {

                                    $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;

                                    $scope.SelectedCE.AdjustedTotal = 0;
                                    $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                    $scope.SelectedCE.UnAssignedAdjusted = 0;
                                    angular.forEach(data.UnassignedBillsArray, function (e) {
                                        $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                        $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                        $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                    })
                                    $('#unassignedModal').modal('show');

                                } else {
                                    toastr.warning("Unassigned Bills Not Found !");
                                }
                            } else {
                                toastr.warning("Unassigned Bills Not Found !");
                            }

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }

            $scope.matchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = ($scope.SelectedCE.CreditAmount + $scope.SelectedCE.DebitAmount);
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                if (bal > 0 && row.BalanceAmount > bal) {
                    row.Adjustment = bal;
                }
                if (bal > 0 && bal >= row.BalanceAmount) {
                    row.Adjustment = row.BalanceAmount;
                }
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.unmatchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = ($scope.SelectedCE.CreditAmount + $scope.SelectedCE.DebitAmount);
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.autoAdjust = function () {

                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var tmp = ($scope.SelectedCE.CreditAmount + $scope.SelectedCE.DebitAmount);

                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    if (tmp > 0) {
                        if (e.BalanceAmount > tmp) {
                            e.Adjustment = tmp;
                            tmp = 0;
                        } else {
                            e.Adjustment = e.BalanceAmount;
                            tmp = tmp - e.BalanceAmount;
                        }
                        tmp = Math.round(tmp * 100) / 100;
                        //  e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    }
                    $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.removeAdjustment = function () {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    e.Adjustment = 0;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.validateBill = function () {
                var totaladj = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    totaladj = totaladj + e.Adjustment;
                })
                if (totaladj > $scope.SelectedCE.Amount) {
                    toastr.warning("Amount exeeding, Values will reset");
                    // angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    //     e.Adjustment = 0;
                    //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    // })
                } else {
                    angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                        e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    })
                }
            }


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;
                $scope.CurrentJV.TotalCredit = 0;
                $scope.CurrentJV.TotalDebit = 0;

                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {

                    $scope.CurrentJV.TotalDebit = $scope.CurrentJV.TotalDebit + e.DebitAmount;
                    $scope.CurrentJV.TotalCredit = $scope.CurrentJV.TotalCredit + e.CreditAmount;

                });

                $scope.CurrentJV.TotalDebit = Math.round($scope.CurrentJV.TotalDebit * 100) / 100;
                $scope.CurrentJV.TotalCredit = Math.round($scope.CurrentJV.TotalCredit * 100) / 100;

                var a = $scope.CurrentJV.DebitNoteDetails.indexOf(data);

                if (($scope.CurrentJV.DebitNoteDetails.length - 1) == a) {
                    var JVDetail = {
                        Id: "",
                        AccountId: "",
                        CreditAmount: 0,
                        DebitAmount: 0,
                        Remarks: "",
                        Account: {},
                        CostCenters: angular.copy($scope.CostCenters),

                    }
                    $scope.CurrentJV.DebitNoteDetails.push(JVDetail);
                }
            }

            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ErrorText = "";

                $scope.CurrentJV.DateString = $scope.extractDate($scope.CurrentJV.Date);
                if ($scope.CurrentJV.Field16 != null) {
                    $scope.CurrentJV.F16DateString = $scope.extractDate($scope.CurrentJV.Field16);
                }
                if ($scope.CurrentJV.Field17 != null) {
                    $scope.CurrentJV.F17DateString = $scope.extractDate($scope.CurrentJV.Field17);
                }
                if ($scope.CurrentJV.Field18 != null) {
                    $scope.CurrentJV.F18DateString = $scope.extractDate($scope.CurrentJV.Field18);
                }
                if ($scope.CurrentJV.Field19 != null) {
                    $scope.CurrentJV.F19DateString = $scope.extractDate($scope.CurrentJV.Field19);
                }
                if ($scope.CurrentJV.Field20 != null) {
                    $scope.CurrentJV.F20DateString = $scope.extractDate($scope.CurrentJV.Field20);
                }


                if ($scope.CurrentJV.DebitNoteDetails.length <= 0) {
                    $scope.ErrorText = $scope.LanguageData.EnterDetails;
                }

                count = 0;
                count2 = 0;
                var costval = 0;
                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {
                    if ((e.AccountId == "" && (e.CreditAmount > 0 || e.DebitAmount > 0)) || (e.AccountId > 0 && e.CreditAmount == 0 && e.DebitAmount == 0)) {
                        count = count + 1;
                    } else if (e.AccountId == "" && e.CreditAmount == 0 && e.DebitAmount == 0) {
                        count2 = count2 + 1;
                    }

                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }

                    if (e.AccountId > 0 && (e.CreditAmount > 0 || e.DebitAmount > 0)) {
                        e.DebitNoteCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.DebitNoteCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                    if (e.UnassignedBillsArray != null) {
                        var tot = 0;
                        angular.forEach(e.UnassignedBillsArray, function (bil) {
                            tot = tot + bil.Adjustment;
                        })
                        tot = Math.round(tot * 100) / 100;
                        if ((e.CreditAmount + e.DebitAmount) < tot) {
                            $scope.ErrorText = "Adjusted Amount Invalid Please Check " + e.Account.Name;
                        }else{
                            e.UnassignedBillsArrays = e.UnassignedBillsArray;
                        }
                    }
                })

                $scope.CurrentJV.DebitNoteCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.CurrentJV.DebitNoteCosts.push(cst);
                            }
                        }
                    }
                })


                if (count > 0) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                }
                if (count2 == $scope.CurrentJV.DebitNoteDetails.length) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                }
                if ($scope.CurrentJV.TotalCredit != $scope.CurrentJV.TotalDebit) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentJV.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentJV.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                } else {
                    if ($scope.ErrorText == "") {
                        $('#saveModal').modal('show');
                    } else {
                        toastr.warning($scope.ErrorText);
                    }
                }
            }

            $scope.SaveWithConfirm = function () {
                $scope.Load = true;
                $scope.CurrentJV.VoucherDocs = $scope.VoucherDocs;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.addDebitNote($scope.CurrentJV).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Debit Note', $scope.CurrentJV.VocherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("DebitNote");
                } else {
                    $scope.Init();
                }

            }

            $scope.ViewVouchers = function () {
                if (!$scope.TokenInfo.IsView && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToViewData);
                } else {
                    viewJVFactory.select().then(function (_selectedReceipt) {
                        if (_selectedReceipt != null) {
                            loadViewDatas(_selectedReceipt);
                        }
                    })
                }
            }

            var loadViewDatas = function (_selectedReceipt) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCN(_selectedReceipt.Id).then(function (response) {
                    $scope.CurrentJV = response.data[0];
                    $scope.CurrentJV.Date = new Date($scope.CurrentJV.Date);

                    angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {
                        if (e.BuildingId > 0) {
                            $scope.getFlats(e);
                        }

                        if (e.VehicleCategoryId > 0) {
                            $scope.getVehicles(e);
                        }
                    })

                    if ($scope.CurrentJV.DebitNoteDetails.length <= 10) {

                        var temp2 = 10 - $scope.CurrentJV.DebitNoteDetails.length;

                        if (temp2 > 0) {
                            for (var i = 0; i < temp2; i++) {


                                var JVDetail = {
                                    Id: "",
                                    AccountId: "",
                                    CreditAmount: 0,
                                    DebitAmount: 0,
                                    Remarks: "",
                                    Account: {},
                                    Flats: [],
                                    CostCenters: angular.copy($scope.CostCenters),

                                }
                                $scope.CurrentJV.DebitNoteDetails.push(JVDetail);
                            }
                        }
                    }

                    $.LoadingOverlay("hide");
                    $scope.Load = false;
                }, function (err) {
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            };

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {

                    if ($scope.CurrentJV.Id > 0) {
                        $('#deleteModal').modal('show');
                    }
                }
            }

            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteDN($scope.CurrentJV.Id).then(function (response) {
                    toastr.success("Success");
                    $scope.Load = false;
                    $('#deleteModal').modal('hide');
                    $state.go("DebitNote");
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.NetworkErrorLan);
                    $.LoadingOverlay("hide");
                })
            }

            $scope.getFlats = function (row) {
                $scope.Load = true;

                MainService.FlatsByBuildingId(row.BuildingId).then(function (response) {
                    row.Flats = response.data;
                    $scope.Load = false;

                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }

            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {

                var JVDetail = {
                    Id: "",
                    AccountId: "",
                    CreditAmount: 0,
                    DebitAmount: 0,
                    Remarks: "",
                    Account: {},
                    Flats: [],
                    CostCenters: angular.copy($scope.CostCenters),
                }

                $scope.CurrentJV.DebitNoteDetails.push(JVDetail);
            }

            $scope.deleteRow = function () {
                var index = $scope.CurrentJV.DebitNoteDetails.indexOf($scope.ClickedRow);
                $scope.CurrentJV.DebitNoteDetails.splice(index, 1);

                $scope.CurrentJV.TotalCredit = 0;
                $scope.CurrentJV.TotalDebit = 0;


                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {

                    $scope.CurrentJV.TotalDebit = $scope.CurrentJV.TotalDebit + e.DebitAmount;
                    $scope.CurrentJV.TotalCredit = $scope.CurrentJV.TotalCredit + e.CreditAmount;

                });
            }


            $scope.GetBackDebitNote = function (type) {
                var temp = 0;
                if ($scope.CurrentJV.Id > 0) {
                    temp = $scope.CurrentJV.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackDebitNote(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.getAccountByName = function () {

                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (e) {

                    if (e.AccountCode != null && e.AccountCode != "" && e.AccountCode != "" && e.AccountName !=
                        null && e.AccountName != "" && e.AccountName != "") {

                        MainService.getAccountByName(e.AccountCode, e.AccountName).then(function (response) {
                            if (response.data) {
                                e.AccountId = response.data.Id;
                                e.Account = response.data;
                            } else {
                                toastr.warning($scope.LanguageData.AccountNotFound + e.AccountName);
                            }
                        }, function () {
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    }
                });
            }

            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                $scope.CurrentJV.DebitNoteDetails = [];

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        angular.forEach(oJS, function (e) {

                            e.AccountCode = e.AccountCode;
                            e.AccountName = e.AccountName;
                            e.AccountId = "";
                            e.Account = {};
                            e.CreditAmount = parseFloat(e.Credit);
                            e.DebitAmount = parseFloat(e.Debit);
                            e.Narration = e.Remarks;

                            e.CostCenters = angular.copy($scope.CostCenters);

                        });

                        $scope.CurrentJV.DebitNoteDetails = oJS;

                        var length = 10 - $scope.CurrentJV.DebitNoteDetails.length;

                        for (var i = 0; i < length; i++) {

                            var OpeningBalanceDetails = {
                                Id: "",
                                AccountId: "",
                                CreditAmount: 0,
                                DebitAmount: 0,
                                Account: {},
                                CostCenters: angular.copy($scope.CostCenters),
                            }

                            $scope.CurrentJV.DebitNoteDetails.push(OpeningBalanceDetails);
                        }

                        $scope.$apply();
                        $scope.getAccountByName();

                    });
                };

                reader.readAsBinaryString(oFile);
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentJV.DebitNoteDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentJV.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentJV.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentJV.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentJV.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentJV.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };



            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };



                }])
